import React, { useState, useContext, useEffect, useRef } from "react";
import "../../../../Users/homepage.css";
import "../../../../Users/pages/innercss.css";
import { Form, Link, redirect } from "react-router-dom";
import { useParams } from "react-router-dom";
import { apiurl } from "../../../../../path";
import UserApplication from "../../../../Users/UserContext/UserContext";
import {
  AddFile32,
  VendorName32,
  Bank32,
  barely_black_bg_img,
  Cancel32,
  Email32,
  Location32,
  PhoneNumber32,
  submit,
} from "../../../../../public/LoginImages/importimages";

// const CreateContractor = () => {
//   let data = useContext(UserApplication);
//   const {
//     SetNotification,
//     paymentdata,
//     GetAuctionsList,
//     TenderRegisterHash,
//     TenderPayment,
//     DownloadReciept,
//     setpaymentdata,
//   } = data;
//   const [form, setform] = useState([]);
//   const [Auction, SetAuction] = useState([]);
//   const { Auction_ID, Auction_Name } = useParams();
//   const [loading, setLoading] = useState(false);

//   const [forminf, SetForminf] = useState({
//     Bidder_CompanyName: "",
//     Address: "",
//     City: "",
//     PinCode: "",
//     GST_No: "",
//     PAN_No: "",
//     TAN_No: "",
//     AadharNo: "",
//     Mobile_No: "",
//     Email: "",
//     Tender_ID: "",
//     Tender_Name: "",
//     TenderFee: "",
//     ErnestMoneyDeposit: "",
//     GST: "",
//     Account_Number: "",
//     IFSC_CODE: "",
//     BANK_NAME: "",
//     MICRNo: "",
//     BranchName: "",
//   });

//   console.log(forminf.IFSC_CODE);
//   const [formErrors, setFormErrors] = useState({
//     Bidder_CompanyName: "",
//     Address: "",
//     City: "",
//     PinCode: "",
//     GST_No: "",
//     PAN_No: "",
//     TAN_No: "",
//     AadharNo: "",
//     Mobile_No: "",
//     Email: "",
//     Tender_ID: "",
//     Tender_Name: "",
//     TenderFee: "",
//     ErnestMoneyDeposit: "",
//     GST: "",
//     Account_Number: "",
//     IFSC_CODE: "",
//     BANK_NAME: "",
//     MICRNo: "",
//     BranchName: "",
//   });

//   const [recieptview, showrecieptview] = useState(true);
//   const [isGSTValid, setIsGSTValid] = useState(null);
//   const [isPANValid, setIsPANValid] = useState(null);
//   const [isTANValid, setIsTANValid] = useState(null);
//   const [accountnum, setaccountnum] = useState(null);

//   const [isIfscValid, setIsIfscValid] = useState(null);
//   const formdataref = useRef(null);
//   const validateIfsc = async () => {
//     let IFSC_CODE = document.getElementById("IFSC_CODE").value.toUpperCase();
//     try {
//       const response = await fetch(`https://ifsc.razorpay.com/${IFSC_CODE}`);
//       if (response.ok) {
//         setIsIfscValid(true);
//       } else {
//         setIsIfscValid(false);
//       }
//     } catch (error) {
//       setIsIfscValid(false);
//       console.error("Error validating IFSC code:", error);
//     }
//   };

//   const checkGSTandPAN = (id, value) => {
//     const gstRegex =
//       /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
//     const panRegex = /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/;

//     if (id === "GST_No") {
//       setIsGSTValid(value.trim() === "" ? null : gstRegex.test(value));
//     }

//     if (id === "PAN_No") {
//       setIsPANValid(value.trim() === "" ? null : panRegex.test(value));
//     }
//     if (id === "TAN_No") {
//       setIsTANValid(value.trim() === "" ? null : panRegex.test(value));
//     }
//   };

//   useEffect(() => {
//     try {
//       setpaymentdata(null);
//       // getdata()
//     } catch (error) {
//       console.error("Error in useEffect:", error);
//       throw error;
//     }
//   }, []);

//   const setdata = (e) => {
//     try {
//       let check = document.getElementById("checkacnumber").value;
//       let acnum = document.getElementById("Account_Number").value;
//       if (check === "" || acnum === "") {
//         setaccountnum(null);
//       } else {
//         setaccountnum(check === acnum ? true : false);
//       }
//       // setaccountnum(check === acnum && check !== "" && acnum !== "" ? true : false);

//       const { id, value } = e.target;
//       let finalValue = value;
//       let errorMessage = "";
//       // const validUserName = /^[a-zA-Z0-9]*$/;
//       const validUserName = /^[a-zA-Z\s]*$/;
//       const validPinCode = /^[0-9]{6}$/;
//       const validMobile = /^[0-9]{10}$/;
//       const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//       const validAccountNumber = /^[0-9]{6,18}$/;
//       if (
//         (id === "Bidder_CompanyName" ||
//           id === "Address" ||
//           id === "City" ||
//           id === "BANK_NAME" ||
//           id === "Account_HolderName" ||
//           id === "BranchName") &&
//         !validUserName.test(value)
//       ) {
//         return;
//         // simply stop updating, no error message shown
//       }
//       if (id === "PinCode") {
//         if (value === "") {
//           errorMessage = "";
//         } else if (!validPinCode.test(value)) {
//           errorMessage = "Pin code must be exactly 6 digits.";
//         } else {
//           errorMessage = "";
//         }
//       }
//       // Ensure IFSC_CODE is always uppercase
//       if (id === "IFSC_CODE") {
//         finalValue = value.toUpperCase();
//       }

//       if (id === "MobileNumber" && !validMobile.test(value)) {
//         errorMessage = "Mobile number must be exactly 10 digits.";
//       }
//       if (id === "Email") {
//         if (value === "") {
//           errorMessage = "";
//         } else if (!validEmail.test(value)) {
//           errorMessage = "Invalid email format. Example: abc@example.com.";
//         } else {
//           errorMessage = "";
//         }
//       }

//       if (id === "checkacnumber" && !validAccountNumber.test(value)) {
//         errorMessage = "Account number must be 6 to 18 digits.";
//       }
//       // Update form state
//       SetForminf((prev) => ({ ...prev, [id]: finalValue }));
//       setFormErrors((prev) => ({ ...prev, [id]: errorMessage }));
//       // Perform validation only for GST_No and PAN_No
//       if (id === "GST_No" || id === "PAN_No") {
//         checkGSTandPAN(id, finalValue);
//       }
//     } catch (error) {
//       console.error("Error in onSubmit:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   var upload = new FormData();

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     let token = localStorage.getItem("Token");
//     try {
//       for (const key in forminf) {
//         upload.append(key, forminf[key]);
//       }
//       let PassbookDoc = document.getElementById("PassbookDoc").files;
//       upload.append("PassbookDoc", PassbookDoc[0]);
//       let ChequeDoc = document.getElementById("ChequeDoc").files;
//       upload.append("ChequeDoc", ChequeDoc[0] || "NA");
//       let PanDoc = document.getElementById("PanDoc").files;
//       upload.append("PanDoc", PanDoc[0]);
//       let TanDoc = document.getElementById("TanDoc").files;
//       upload.append("TanDoc", TanDoc[0] || "NA");
//       let GstDoc = document.getElementById("GstDoc").files;
//       upload.append("GstDoc", GstDoc[0]);
//       let AadharDoc = document.getElementById("AadharDoc").files;
//       upload.append("AadharDoc", AadharDoc[0] || "NA");

//       console.log("upload", upload);
//       const response = await fetch(
//         `${apiurl}/VendorManagement/ContractorRegistration`,
//         {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: upload,
//         },
//       );
//       const data = await response.json();
//       console.log(data);
//       if (data.message) {
//         alert(data.message);
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error("Error in onSubmit:", error);
//       throw error;
//     }
//   };
//   const resetData = () => {
//     formdataref.current.reset();
//     SetForminf([]);
//   };
//   return (
//     <div
//       style={{
//         // marginLeft: "18.5rem",
//         // transition: "margin-left 0.3s ease",
//         // backgroundColor: "#efecff",
//         // minHeight: "100vh",
//         // width: "100%",
//         // display: "flex",
//         // flexDirection: "column",
//         // justifyContent: "center",
//         // alignItems: "center",
//         // padding: "30px",
//         // boxSizing: "border-box",
//         // overflowY: "auto",
//         background: "#efecff",
//         width: "auto",
//         maxHeight: "92vh",
//         // minHeight: '100vh',
//         transition: "margin-left 0.3s ease",
//         overflowY: "auto",
//         msOverflowStyle: "none", // IE & Edge
//         scrollbarWidth: "none",

//         padding: 40,
//         fontFamily: "Inter, sans-serif",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           // background: "linear-gradient(100deg, #d7e5f5, #e9effc)",
//           background: "linear-gradient(100deg, #bbd2ebff, #8ea1c9ff)",
//           padding: "12px 0",
//           boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//           width: "auto",
//           // marginRight: "20px",
//           // marginLeft: "-30px",
//           marginBottom: "20px",
//           paddingRight: "200px",
//         }}
//       >
//         <i
//           className="fa fa-user"
//           style={{
//             marginRight: "8px",
//             color: "#044c92",
//             fontSize: "18px",
//           }}
//         ></i>
//         <h5
//           style={{
//             margin: 0,
//             color: "#044c92",
//             fontWeight: 700,
//             fontSize: "18px",
//           }}
//         >
//           Vendor Registration
//         </h5>
//       </div>
//       <Form
//         id="form1"
//         ref={formdataref}
//         onSubmit={(e) => {
//           isPANValid === true && accountnum === true && isIfscValid === true
//             ? onSubmit(e)
//             : alert("incorrect details");
//         }}
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           // width: "100%",
//           // maxWidth: "1130px",
//           // marginLeft: "20px",
//           backgroundColor: "#ffffff",
//           boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//           borderRadius: "15px",
//           padding: "30px",
//         }}
//       >
//         <h6
//           style={{
//             marginBottom: "20px",
//             fontWeight: "700",
//             color: "black",
//             textAlign: "left",
//             width: "100%",
//           }}
//         >
//           <img
//             src={"/Personal-Details-64.png"}
//             alt="Project Icon"
//             style={{ marginRight: "10px", width: 28, height: 28 }}
//           />
//           Personal Details
//         </h6>
//         {/* Personal Details Section */}
//         <div
//           style={{
//             width: "100%",
//             maxWidth: "1200px",
//             backgroundColor: "#f3f8fd",
//             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//             borderRadius: "10px",
//             padding: "20px",
//             marginBottom: "20px",
//           }}
//         >
//           <div
//             style={{
//               display: "grid",
//               gap: "20px",
//               width: "100%",
//               gridTemplateColumns: "1fr 1fr",
//             }}
//           >
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Vendor Name
//               </label>
//               <div style={{ position: "relative" }}>
//                 <input
//                   type="text"
//                   id="Bidder_CompanyName"
//                   placeholder="Enter Vendor Name"
//                   style={{
//                     border: "1px solid #ccc",
//                     borderRadius: "5px",
//                     padding: "10px",
//                   }}
//                   className="form-control"
//                   required
//                   onChange={(e) => {
//                     setdata(e);
//                   }}
//                 />
//                 <img
//                   src={VendorName32}
//                   alt="Email Icon"
//                   style={{
//                     position: "absolute",
//                     right: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     width: "20px",
//                     height: "20px",
//                   }}
//                 />
//               </div>
//               {formErrors.Bidder_CompanyName && (
//                 <small style={{ color: "red", fontWeight: "bold" }}>
//                   {formErrors.Bidder_CompanyName}
//                 </small>
//               )}
//             </div>

//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Address
//               </label>
//               <div style={{ position: "relative" }}>
//                 <input
//                   type="text"
//                   id="Address"
//                   placeholder="Enter Address"
//                   className="form-control"
//                   style={{
//                     border: "1px solid #ccc",
//                     borderRadius: "5px",
//                     padding: "10px",
//                   }}
//                   required
//                   onChange={(e) => {
//                     setdata(e);
//                   }}
//                 />
//                 <img
//                   src={Location32}
//                   alt="Email Icon"
//                   style={{
//                     position: "absolute",
//                     right: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     width: "20px",
//                     height: "20px",
//                   }}
//                 />
//               </div>
//               {formErrors.Address && (
//                 <small style={{ color: "red", fontWeight: "bold" }}>
//                   {formErrors.Address}
//                 </small>
//               )}
//             </div>

//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Mobile No
//               </label>
//               <div style={{ position: "relative" }}>
//                 <input
//                   type="text"
//                   className="form-control"
//                   style={{
//                     border: "1px solid #ccc",
//                     borderRadius: "5px",
//                     padding: "10px",
//                   }}
//                   id="Mobile_No"
//                   pattern="\d{10}"
//                   minLength="10"
//                   maxLength="10"
//                   placeholder="Enter Mobile No"
//                   onInput={(e) => {
//                     let enteredValue = e.target.value;
//                     enteredValue = enteredValue.slice(0, 10).replace(/\D/g, "");
//                     e.target.value = enteredValue;
//                   }}
//                   onChange={(e) => {
//                     setdata(e);
//                   }}
//                   required
//                 />
//                 <img
//                   src={PhoneNumber32}
//                   alt="Email Icon"
//                   style={{
//                     position: "absolute",
//                     right: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     width: "20px",
//                     height: "20px",
//                   }}
//                 />
//               </div>
//               {formErrors.MobileNumber && (
//                 <small style={{ color: "red", fontWeight: "bold" }}>
//                   {formErrors.MobileNumber}
//                 </small>
//               )}
//             </div>

//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Email
//               </label>
//               <div style={{ position: "relative" }}>
//                 <input
//                   type="email"
//                   id="Email"
//                   placeholder="Enter Email"
//                   className="form-control pe-5"
//                   style={{
//                     border: "1px solid #ccc",
//                     borderRadius: "5px",
//                     padding: "10px",
//                   }}
//                   required
//                   onChange={(e) => setdata(e)}
//                 />
//                 <img
//                   src={Email32}
//                   alt="Email Icon"
//                   style={{
//                     position: "absolute",
//                     right: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     width: "20px",
//                     height: "20px",
//                   }}
//                 />
//               </div>
//               {formErrors.Email && (
//                 <small style={{ color: "red", fontWeight: "bold" }}>
//                   {formErrors.Email}
//                 </small>
//               )}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Pin Code<label style={{ color: "red" }}>*</label> :
//               </label>
//               <div style={{ position: "relative" }}>
//                 <input
//                   type="tel"
//                   id="PinCode"
//                   pattern="\d{6}"
//                   minLength="6"
//                   maxLength="6"
//                   placeholder="Enter Pin Code"
//                   className="form-control pe-5"
//                   onInput={(e) => {
//                     let enteredValue = e.target.value;
//                     enteredValue = enteredValue.slice(0, 6).replace(/\D/g, "");
//                     e.target.value = enteredValue;
//                   }}
//                   onChange={(e) => {
//                     setdata(e);
//                   }}
//                   style={{
//                     border: "1px solid #ccc",
//                     borderRadius: "5px",
//                     padding: "10px",
//                   }}
//                   required
//                 />
//               </div>
//               {formErrors.PinCode && (
//                 <small style={{ color: "red", fontWeight: "bold" }}>
//                   {formErrors.PinCode}
//                 </small>
//               )}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 City<label style={{ color: "red" }}>*</label> :
//               </label>
//               <input
//                 type="text"
//                 id="City"
//                 placeholder="Enter City"
//                 className="form-control"
//                 style={{
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//                 required
//                 onChange={(e) => {
//                   setdata(e);
//                 }}
//               />
//               {formErrors.City && (
//                 <small style={{ color: "red", fontWeight: "bold" }}>
//                   {formErrors.City}
//                 </small>
//               )}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 PAN Number<label style={{ color: "red" }}>*</label> :
//               </label>
//               <input
//                 type="text"
//                 id="PAN_No"
//                 placeholder="Enter PAN No."
//                 className="form-control pe-5"
//                 required
//                 onChange={(e) => {
//                   setdata(e);
//                   checkGSTandPAN();
//                 }}
//                 style={{
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//                 value={forminf.PAN_No || ""}
//                 minLength={10}
//                 maxLength={10}
//               />
//               {isPANValid === false && (
//                 <b style={{ color: "red" }}>Invalid PAN</b>
//               )}
//               {isPANValid === true && <b style={{ color: "green" }}>Valid</b>}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 TAN Number :
//               </label>
//               <input
//                 type="text"
//                 id="TAN_No"
//                 placeholder="Enter TAN No."
//                 className="form-control pe-5"
//                 onChange={(e) => {
//                   setdata(e);
//                   checkGSTandPAN();
//                 }}
//                 style={{
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//                 value={forminf.TAN_No || ""}
//                 minLength={10}
//                 maxLength={10}
//               />
//               {isTANValid === false && (
//                 <b style={{ color: "red" }}>Invalid TAN</b>
//               )}
//               {isTANValid === true && <b style={{ color: "green" }}>Valid</b>}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 GST Number<label style={{ color: "red" }}>*</label> :
//               </label>
//               <input
//                 type="text"
//                 id="GST_No"
//                 placeholder="Enter GST No."
//                 className="form-control pe-5"
//                 required
//                 onChange={(e) => {
//                   setdata(e);
//                   checkGSTandPAN();
//                 }}
//                 style={{
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//                 value={forminf.GST_No || ""}
//                 minLength={15}
//                 maxLength={15}
//               />
//               {isGSTValid === false && (
//                 <b style={{ color: "red" }}>Incorrect GST</b>
//               )}
//               {isGSTValid === true && <b style={{ color: "green" }}>Correct</b>}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Aadhar Number<label style={{ color: "red" }}>*</label> :
//               </label>
//               <div style={{ position: "relative" }}>
//                 <input
//                   type="text"
//                   id="AadharNo"
//                   placeholder="Enter Aadhar No."
//                   className="form-control pe-5"
//                   required
//                   onChange={(e) => {
//                     setdata(e);
//                     checkGSTandPAN();
//                   }}
//                   style={{}}
//                   value={forminf.AadharNo || ""}
//                   minLength={12}
//                   maxLength={12}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Bank Details Section */}
//         <h6
//           style={{
//             marginBottom: "20px",
//             fontWeight: "700",
//             color: "black",
//             textAlign: "left",
//             width: "100%",
//           }}
//         >
//           <img
//             src={"/Bank-Master-32.png"}
//             alt="Project Icon"
//             style={{ marginRight: "10px", width: 28, height: 28 }}
//           />
//           Bank Details
//         </h6>
//         <div
//           style={{
//             width: "100%",
//             maxWidth: "1200px",
//             backgroundColor: "#f3f8fd",
//             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//             borderRadius: "10px",
//             padding: "20px",
//             marginBottom: "20px",
//           }}
//         >
//           <div
//             style={{
//               display: "grid",
//               gap: "20px",
//               width: "100%",
//               gridTemplateColumns: "1fr 1fr",
//             }}
//           >
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 IFSC Code<label style={{ color: "red" }}>*</label> :
//               </label>
//               <input
//                 type="text"
//                 id="IFSC_CODE"
//                 placeholder="Enter IFSC Code"
//                 className="form-control"
//                 required
//                 onChange={(e) => {
//                   setdata(e);
//                   validateIfsc();
//                 }}
//                 style={{
//                   textTransform: "uppercase",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//               />
//               {isIfscValid !== null && (
//                 <b style={{ color: isIfscValid === false ? "red" : "green" }}>
//                   {isIfscValid === false
//                     ? "IFSC Code is invalid"
//                     : "IFSC code is valid"}
//                 </b>
//               )}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 MICR Code :
//               </label>
//               <input
//                 type="text"
//                 id="MICRCode"
//                 placeholder="Enter MICR Code"
//                 className="form-control"
//                 style={{
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//                 required
//                 onChange={(e) => {
//                   setdata(e);
//                 }}
//               />
//               {/* {formErrors.BranchName && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BranchName}</small>)} */}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Bank Name<label style={{ color: "red" }}>*</label> :
//               </label>
//               <input
//                 type="text"
//                 id="BANK_NAME"
//                 placeholder="Enter Bank Name"
//                 className="form-control"
//                 style={{
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//                 required
//                 onChange={(e) => {
//                   setdata(e);
//                 }}
//               />
//               {formErrors.BANK_NAME && (
//                 <small style={{ color: "red", fontWeight: "bold" }}>
//                   {formErrors.BANK_NAME}
//                 </small>
//               )}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Branch Name<label style={{ color: "red" }}>*</label> :
//               </label>
//               <input
//                 type="text"
//                 id="BranchName"
//                 placeholder="Branch Name"
//                 className="form-control"
//                 style={{
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//                 required
//                 onChange={(e) => {
//                   setdata(e);
//                 }}
//               />
//               {formErrors.BranchName && (
//                 <small style={{ color: "red", fontWeight: "bold" }}>
//                   {formErrors.BranchName}
//                 </small>
//               )}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Account Number<label style={{ color: "red" }}>*</label> :
//               </label>
//               <input
//                 type="text"
//                 id="checkacnumber"
//                 placeholder="Enter Account Number"
//                 className="form-control"
//                 style={{
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//                 required
//                 onChange={(e) => {
//                   setdata(e);
//                 }}
//               />
//               {formErrors.checkacnumber && (
//                 <small style={{ color: "red", fontWeight: "bold" }}>
//                   {formErrors.checkacnumber}
//                 </small>
//               )}
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 {" "}
//                 Confirm Account Number<label style={{ color: "red" }}>
//                   *
//                 </label>{" "}
//                 :
//               </label>
//               <input
//                 type="text"
//                 id="Account_Number"
//                 placeholder="Confirm Account Number"
//                 className="form-control"
//                 style={{
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   padding: "10px",
//                 }}
//                 required
//                 onChange={(e) => {
//                   setdata(e);
//                 }}
//               />
//               {accountnum !== null && (
//                 <b style={{ color: accountnum === false ? "red" : "green" }}>
//                   {accountnum === false
//                     ? "Account number does not match"
//                     : "Matched"}
//                 </b>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Documents Section */}
//         <h6
//           style={{
//             marginBottom: "20px",
//             fontWeight: "700",
//             color: "black",
//             textAlign: "left",
//             width: "100%",
//           }}
//         >
//           <img
//             src={"/Documents-32.png"}
//             alt="Project Icon"
//             style={{ marginRight: "10px", width: 28, height: 28 }}
//           />
//           Documents
//         </h6>
//         <div
//           style={{
//             width: "100%",
//             maxWidth: "1200px",
//             backgroundColor: "#f3f8fd",
//             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//             borderRadius: "10px",
//             padding: "20px",
//           }}
//         >
//           <div
//             style={{
//               display: "grid",
//               gap: "20px",
//               width: "100%",
//               gridTemplateColumns: "1fr 1fr",
//             }}
//           >
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Passbook Upload
//               </label>
//               <input type="file" className="form-control" id="PassbookDoc" />
//               <small style={{ color: "red", fontWeight: "bold" }}>
//                 {formErrors.passbook && formErrors.passbook}
//               </small>
//             </div>

//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Cheque Upload
//               </label>
//               <input type="file" className="form-control" id="ChequeDoc" />
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Pan Upload
//                 <span style={{ color: "red" }}>*</span> :
//               </label>
//               <input
//                 type="file"
//                 id="PanDoc"
//                 className="form-control"
//                 required
//               />
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Tan Upload
//               </label>
//               <input type="file" id="TanDoc" className="form-control" />
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 GST Upload
//                 <span style={{ color: "red" }}>*</span> :
//               </label>
//               <input
//                 type="file"
//                 id="GstDoc"
//                 className="form-control"
//                 required
//               />
//             </div>
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <label
//                 className="form-label"
//                 style={{ fontWeight: "700", marginBottom: "10px" }}
//               >
//                 Aadhaar Upload
//                 <span style={{ color: "red" }}>*</span> :
//               </label>
//               <input
//                 type="file"
//                 id="AadharDoc"
//                 className="form-control"
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Submit and Cancel Buttons */}
//         <div
//           style={{
//             display: "flex",
//             gap: "20px",
//             marginTop: "20px",
//             justifyContent: "center",
//           }}
//         >
//           <button
//             type="submit"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               borderRadius: "20px",
//               width: "120px",
//               height: "40px",
//               backgroundColor: "#39b54a",
//               border: "none",
//               fontSize: "16px",
//               color: "#ffffff",
//               fontWeight: "700",
//             }}
//           >
//             <img
//               src={submit}
//               style={{
//                 width: "1.2rem",
//                 paddingBottom: "3px",
//                 fontSize: "15px",
//               }}
//             />
//             Submit
//           </button>
//           <button
//             onClick={resetData}
//             type="button"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               borderRadius: "20px",
//               width: "120px",
//               height: "40px",
//               backgroundColor: "#ee5d50",
//               // opacity: "50%",
//               border: "none",
//               fontSize: "16px",
//               color: "#ffffff",
//               fontWeight: "700",
//             }}
//           >
//             <img src={Cancel32} style={{ width: "1.2rem" }} />
//             Cancel
//           </button>
//         </div>
//       </Form>
//     </div>
//   );
// };


const CreateContractor = () => {
  let data = useContext(UserApplication);
  const {
    SetNotification,
    paymentdata,
    GetAuctionsList,
    TenderRegisterHash,
    TenderPayment,
    DownloadReciept,
    setpaymentdata,
  } = data;
  const [form, setform] = useState([]);
  const [Auction, SetAuction] = useState([]);
  const { Auction_ID, Auction_Name } = useParams();
  const [loading, setLoading] = useState(false);

  const [forminf, SetForminf] = useState({
    Bidder_CompanyName: "",
    Address: "",
    City: "",
    PinCode: "",
    GST_No: "",
    PAN_No: "",
    TAN_No: "",
    AadharNo: "",
    Mobile_No: "",
    Email: "",
    Tender_ID: "",
    Tender_Name: "",
    TenderFee: "",
    ErnestMoneyDeposit: "",
    GST: "",
    Account_Number: "",
    IFSC_CODE: "",
    BANK_NAME: "",
    MICRNo: "",
    BranchName: "",
  });

  console.log(forminf.IFSC_CODE);
  const [formErrors, setFormErrors] = useState({
    Bidder_CompanyName: "",
    Address: "",
    City: "",
    PinCode: "",
    GST_No: "",
    PAN_No: "",
    TAN_No: "",
    AadharNo: "",
    Mobile_No: "",
    Email: "",
    Tender_ID: "",
    Tender_Name: "",
    TenderFee: "",
    ErnestMoneyDeposit: "",
    GST: "",
    Account_Number: "",
    IFSC_CODE: "",
    BANK_NAME: "",
    MICRNo: "",
    BranchName: "",
  });

  const [recieptview, showrecieptview] = useState(true);
  const [isGSTValid, setIsGSTValid] = useState(null);
  const [isPANValid, setIsPANValid] = useState(null);
  const [isTANValid, setIsTANValid] = useState(null);
  const [accountnum, setaccountnum] = useState(null);

  const [isIfscValid, setIsIfscValid] = useState(null);
  const formdataref = useRef(null);
  const validateIfsc = async () => {
    let IFSC_CODE = document.getElementById("IFSC_CODE").value.toUpperCase();
    try {
      const response = await fetch(`https://ifsc.razorpay.com/${IFSC_CODE}`);
      if (response.ok) {
        setIsIfscValid(true);
      } else {
        setIsIfscValid(false);
      }
    } catch (error) {
      setIsIfscValid(false);
      console.error("Error validating IFSC code:", error);
    }
  };

  const checkGSTandPAN = (id, value) => {
    const gstRegex =
      /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
    const panRegex = /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/;

    if (id === "GST_No") {
      setIsGSTValid(value.trim() === "" ? null : gstRegex.test(value));
    }

    if (id === "PAN_No") {
      setIsPANValid(value.trim() === "" ? null : panRegex.test(value));
    }
    if (id === "TAN_No") {
      setIsTANValid(value.trim() === "" ? null : panRegex.test(value));
    }
  };

  useEffect(() => {
    try {
      setpaymentdata(null);
      // getdata()
    } catch (error) {
      console.error("Error in useEffect:", error);
      throw error;
    }
  }, []);

  const setdata = (e) => {
    try {
      let check = document.getElementById("checkacnumber").value;
      let acnum = document.getElementById("Account_Number").value;
      if (check === "" || acnum === "") {
        setaccountnum(null);
      } else {
        setaccountnum(check === acnum ? true : false);
      }
      // setaccountnum(check === acnum && check !== "" && acnum !== "" ? true : false);

      const { id, value } = e.target;
      let finalValue = value;
      let errorMessage = "";
      // const validUserName = /^[a-zA-Z0-9]*$/;
      const validUserName = /^[a-zA-Z\s]*$/;
      const validPinCode = /^[0-9]{6}$/;
      const validMobile = /^[0-9]{10}$/;
      const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const validAccountNumber = /^[0-9]{6,18}$/;
      if (
        (id === "Bidder_CompanyName" ||
          id === "Address" ||
          id === "City" ||
          id === "BANK_NAME" ||
          id === "Account_HolderName" ||
          id === "BranchName") &&
        !validUserName.test(value)
      ) {
        return;
        // simply stop updating, no error message shown
      }
      if (id === "PinCode") {
        if (value === "") {
          errorMessage = "";
        } else if (!validPinCode.test(value)) {
          errorMessage = "Pin code must be exactly 6 digits.";
        } else {
          errorMessage = "";
        }
      }
      // Ensure IFSC_CODE is always uppercase
      if (id === "IFSC_CODE") {
        finalValue = value.toUpperCase();
      }

      if (id === "MobileNumber" && !validMobile.test(value)) {
        errorMessage = "Mobile number must be exactly 10 digits.";
      }
      if (id === "Email") {
        if (value === "") {
          errorMessage = "";
        } else if (!validEmail.test(value)) {
          errorMessage = "Invalid email format. Example: abc@example.com.";
        } else {
          errorMessage = "";
        }
      }

      if (id === "checkacnumber" && !validAccountNumber.test(value)) {
        errorMessage = "Account number must be 6 to 18 digits.";
      }
      // Update form state
      SetForminf((prev) => ({ ...prev, [id]: finalValue }));
      setFormErrors((prev) => ({ ...prev, [id]: errorMessage }));
      // Perform validation only for GST_No and PAN_No
      if (id === "GST_No" || id === "PAN_No") {
        checkGSTandPAN(id, finalValue);
      }
    } catch (error) {
      console.error("Error in onSubmit:", error);
    } finally {
      setLoading(false);
    }
  };

  var upload = new FormData();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let token = localStorage.getItem("Token");
    try {
      for (const key in forminf) {
        upload.append(key, forminf[key]);
      }
      let PassbookDoc = document.getElementById("PassbookDoc").files;
      upload.append("PassbookDoc", PassbookDoc[0]);
      let ChequeDoc = document.getElementById("ChequeDoc").files;
      upload.append("ChequeDoc", ChequeDoc[0] || "NA");
      let PanDoc = document.getElementById("PanDoc").files;
      upload.append("PanDoc", PanDoc[0]);
      let TanDoc = document.getElementById("TanDoc").files;
      upload.append("TanDoc", TanDoc[0] || "NA");
      let GstDoc = document.getElementById("GstDoc").files;
      upload.append("GstDoc", GstDoc[0]);
      let AadharDoc = document.getElementById("AadharDoc").files;
      upload.append("AadharDoc", AadharDoc[0] || "NA");

      console.log("upload", upload);
      const response = await fetch(
        `${apiurl}/VendorManagement/ContractorRegistration`,
        {
          method: "POST",
          headers: { AuthToken: token },
          body: upload,
        },
      );
      const data = await response.json();
      console.log(data);
      if (data.message) {
        alert(data.message);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error in onSubmit:", error);
      throw error;
    }
  };
  const resetData = () => {
  alert("Form has been cancelled.");
 
  formdataref.current.reset();
  SetForminf({  Bidder_CompanyName: "",
    Address: "",
    City: "",
    PinCode: "",
    GST_No: "",
    PAN_No: "",
    TAN_No: "",
    AadharNo: "",
    Mobile_No: "",
    Email: "",
    Tender_ID: "",
    Tender_Name: "",
    TenderFee: "",
    ErnestMoneyDeposit: "",
    GST: "",
    Account_Number: "",
    IFSC_CODE: "",
    BANK_NAME: "",
    MICRNo: "",
    BranchName: "",
  });
 
  setIsGSTValid(null);
  setIsPANValid(null);
  setIsTANValid(null);
  setIsIfscValid(null);
  setaccountnum(null);
};
  return (
    <div
      style={{
        // marginLeft: "18.5rem",
        // transition: "margin-left 0.3s ease",
        // backgroundColor: "#efecff",
        // minHeight: "100vh",
        // width: "100%",
        // display: "flex",
        // flexDirection: "column",
        // justifyContent: "center",
        // alignItems: "center",
        // padding: "30px",
        // boxSizing: "border-box",
        // overflowY: "auto",
        background: "#ffffff",
        width: "auto",
        maxHeight: "92vh",
        // minHeight: '100vh',
        transition: "margin-left 0.3s ease",
        overflowY: "auto",
        msOverflowStyle: "none", // IE & Edge
        scrollbarWidth: "none",
        padding: 40,
        fontFamily: "Inter, sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft:"50px",
          // background: "linear-gradient(100deg, #d7e5f5, #e9effc)",
          // background: "linear-gradient(100deg, #bbd2ebff, #8ea1c9ff)",
          padding: "12px 0",
          // boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          width: "auto",
          // marginRight: "20px",
          // marginLeft: "-30px",
          marginBottom: "20px",
          // paddingRight: "160px",
        }}
      >
        <i
          className="fa fa-user"
          style={{
            marginRight: "8px",
            color: "black",
            fontSize: "18px",
          }}
        ></i>
        <h5
          style={{
            margin: 0,
            color: "black",
            fontWeight: 700,
            fontSize: "20px",
          }}
        >
          Vendor Registration
        </h5>
      </div>
      <Form
        id="form1"
        ref={formdataref}
        onSubmit={(e) => {
          isPANValid === true && accountnum === true && isIfscValid === true
            ? onSubmit(e)
            : alert("incorrect details");
        }}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          // width: "100%",
          // maxWidth: "1130px",
          // marginLeft: "20px",
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "15px",
          padding: "30px",
        }}
      >
        <h6
          style={{
            marginBottom: "20px",
            fontWeight: "700",
            color: "black",
            textAlign: "left",
            width: "100%",
          }}
        >
          <img
            src={"/Personal-Details-64.png"}
            alt="Project Icon"
            style={{ marginRight: "10px", width: 28, height: 28 }}
          />
          Personal Details
        </h6>
        {/* Personal Details Section */}
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            backgroundColor: "#f3f8fd",
            border: "1px solid #afc8df",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "grid",
              gap: "20px",
              width: "100%",
              gridTemplateColumns: "1fr 1fr",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Vendor Name
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  id="Bidder_CompanyName"
                  placeholder="Enter Vendor Name"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                  className="form-control"
                  required
                  onChange={(e) => {
                    setdata(e);
                  }}
                />
                <img
                  src={VendorName32}
                  alt="Email Icon"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "20px",
                    height: "20px",
                  }}
                />
              </div>
              {formErrors.Bidder_CompanyName && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.Bidder_CompanyName}
                </small>
              )}
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Address
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  id="Address"
                  placeholder="Enter Address"
                  className="form-control"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                  required
                  onChange={(e) => {
                    setdata(e);
                  }}
                />
                <img
                  src={Location32}
                  alt="Email Icon"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "20px",
                    height: "20px",
                  }}
                />
              </div>
              {formErrors.Address && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.Address}
                </small>
              )}
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Mobile No
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                  id="Mobile_No"
                  pattern="\d{10}"
                  minLength="10"
                  maxLength="10"
                  placeholder="Enter Mobile No"
                  onInput={(e) => {
                    let enteredValue = e.target.value;
                    enteredValue = enteredValue.slice(0, 10).replace(/\D/g, "");
                    e.target.value = enteredValue;
                  }}
                  onChange={(e) => {
                    setdata(e);
                  }}
                  required
                />
                <img
                  src={PhoneNumber32}
                  alt="Email Icon"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "20px",
                    height: "20px",
                  }}
                />
              </div>
              {formErrors.MobileNumber && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.MobileNumber}
                </small>
              )}
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Email
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type="email"
                  id="Email"
                  placeholder="Enter Email"
                  className="form-control pe-5"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                  required
                  onChange={(e) => setdata(e)}
                />
                <img
                  src={Email32}
                  alt="Email Icon"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "20px",
                    height: "20px",
                  }}
                />
              </div>
              {formErrors.Email && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.Email}
                </small>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Pin Code<label style={{ color: "red" }}>*</label> :
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type="tel"
                  id="PinCode"
                  pattern="\d{6}"
                  minLength="6"
                  maxLength="6"
                  placeholder="Enter Pin Code"
                  className="form-control pe-5"
                  onInput={(e) => {
                    let enteredValue = e.target.value;
                    enteredValue = enteredValue.slice(0, 6).replace(/\D/g, "");
                    e.target.value = enteredValue;
                  }}
                  onChange={(e) => {
                    setdata(e);
                  }}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                  required
                />
              </div>
              {formErrors.PinCode && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.PinCode}
                </small>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                City<label style={{ color: "red" }}>*</label> :
              </label>
              <input
                type="text"
                id="City"
                placeholder="Enter City"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                required
                onChange={(e) => {
                  setdata(e);
                }}
              />
              {formErrors.City && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.City}
                </small>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                PAN Number<label style={{ color: "red" }}>*</label> :
              </label>
              <input
                type="text"
                id="PAN_No"
                placeholder="Enter PAN No."
                className="form-control pe-5"
                required
                onChange={(e) => {
                  setdata(e);
                  checkGSTandPAN();
                }}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                value={forminf.PAN_No || ""}
                minLength={10}
                maxLength={10}
              />
              {isPANValid === false && (
                <b style={{ color: "red" }}>Invalid PAN</b>
              )}
              {isPANValid === true && <b style={{ color: "green" }}>Valid</b>}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                TAN Number :
              </label>
              <input
                type="text"
                id="TAN_No"
                placeholder="Enter TAN No."
                className="form-control pe-5"
                onChange={(e) => {
                  setdata(e);
                  checkGSTandPAN();
                }}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                value={forminf.TAN_No || ""}
                minLength={10}
                maxLength={10}
              />
              {isTANValid === false && (
                <b style={{ color: "red" }}>Invalid TAN</b>
              )}
              {isTANValid === true && <b style={{ color: "green" }}>Valid</b>}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                GST Number<label style={{ color: "red" }}>*</label> :
              </label>
              <input
                type="text"
                id="GST_No"
                placeholder="Enter GST No."
                className="form-control pe-5"
                required
                onChange={(e) => {
                  setdata(e);
                  checkGSTandPAN();
                }}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                value={forminf.GST_No || ""}
                minLength={15}
                maxLength={15}
              />
              {isGSTValid === false && (
                <b style={{ color: "red" }}>Incorrect GST</b>
              )}
              {isGSTValid === true && <b style={{ color: "green" }}>Correct</b>}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Aadhar Number<label style={{ color: "red" }}>*</label> :
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  id="AadharNo"
                  placeholder="Enter Aadhar No."
                  className="form-control pe-5"
                  required
                  onChange={(e) => {
                    setdata(e);
                    checkGSTandPAN();
                  }}
                  style={{}}
                  value={forminf.AadharNo || ""}
                  minLength={12}
                  maxLength={12}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bank Details Section */}
        <h6
          style={{
            marginBottom: "20px",
            fontWeight: "700",
            color: "black",
            textAlign: "left",
            width: "100%",
          }}
        >
          <img
            src={"/Bank-Master-32.png"}
            alt="Project Icon"
            style={{ marginRight: "10px", width: 28, height: 28 }}
          />
          Bank Details
        </h6>
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            backgroundColor: "#f3f8fd",
            border: "1px solid #afc8df",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "grid",
              gap: "20px",
              width: "100%",
              gridTemplateColumns: "1fr 1fr",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                IFSC Code<label style={{ color: "red" }}>*</label> :
              </label>
              <input
                type="text"
                id="IFSC_CODE"
                placeholder="Enter IFSC Code"
                className="form-control"
                required
                onChange={(e) => {
                  setdata(e);
                  validateIfsc();
                }}
                style={{
                  textTransform: "uppercase",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
              />
              {isIfscValid !== null && (
                <b style={{ color: isIfscValid === false ? "red" : "green" }}>
                  {isIfscValid === false
                    ? "IFSC Code is invalid"
                    : "IFSC code is valid"}
                </b>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                MICR Code :
              </label>
              <input
                type="text"
                id="MICRCode"
                placeholder="Enter MICR Code"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                required
                onChange={(e) => {
                  setdata(e);
                }}
              />
              {/* {formErrors.BranchName && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BranchName}</small>)} */}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Bank Name<label style={{ color: "red" }}>*</label> :
              </label>
              <input
                type="text"
                id="BANK_NAME"
                placeholder="Enter Bank Name"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                required
                onChange={(e) => {
                  setdata(e);
                }}
              />
              {formErrors.BANK_NAME && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.BANK_NAME}
                </small>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Branch Name<label style={{ color: "red" }}>*</label> :
              </label>
              <input
                type="text"
                id="BranchName"
                placeholder="Branch Name"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                required
                onChange={(e) => {
                  setdata(e);
                }}
              />
              {formErrors.BranchName && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.BranchName}
                </small>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Account Number<label style={{ color: "red" }}>*</label> :
              </label>
              <input
                type="text"
                id="checkacnumber"
                placeholder="Enter Account Number"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                required
                onChange={(e) => {
                  setdata(e);
                }}
              />
              {formErrors.checkacnumber && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.checkacnumber}
                </small>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                {" "}
                Confirm Account Number<label style={{ color: "red" }}>
                  *
                </label>{" "}
                :
              </label>
              <input
                type="text"
                id="Account_Number"
                placeholder="Confirm Account Number"
                className="form-control"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
                required
                onChange={(e) => {
                  setdata(e);
                }}
              />
              {accountnum !== null && (
                <b style={{ color: accountnum === false ? "red" : "green" }}>
                  {accountnum === false
                    ? "Account number does not match"
                    : "Matched"}
                </b>
              )}
            </div>
          </div>
        </div>

        {/* Documents Section */}
        <h6
          style={{
            marginBottom: "20px",
            fontWeight: "700",
            color: "black",
            textAlign: "left",
            width: "100%",
          }}
        >
          <img
            src={"/Documents-32.png"}
            alt="Project Icon"
            style={{ marginRight: "10px", width: 28, height: 28 }}
          />
          Documents
        </h6>
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            backgroundColor: "#f3f8fd",
            border: "1px solid #afc8df",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <div
            style={{
              display: "grid",
              gap: "20px",
              width: "100%",
              gridTemplateColumns: "1fr 1fr",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Passbook Upload
              </label>
              <input type="file" className="form-control" id="PassbookDoc" />
              <small style={{ color: "red", fontWeight: "bold" }}>
                {formErrors.passbook && formErrors.passbook}
              </small>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Cheque Upload
              </label>
              <input type="file" className="form-control" id="ChequeDoc" />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Pan Upload
                <span style={{ color: "red" }}>*</span> :
              </label>
              <input
                type="file"
                id="PanDoc"
                className="form-control"
                required
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Tan Upload
              </label>
              <input type="file" id="TanDoc" className="form-control" />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                GST Upload
                <span style={{ color: "red" }}>*</span> :
              </label>
              <input
                type="file"
                id="GstDoc"
                className="form-control"
                required
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px" }}
              >
                Aadhaar Upload
                <span style={{ color: "red" }}>*</span> :
              </label>
              <input
                type="file"
                id="AadharDoc"
                className="form-control"
                required
              />
            </div>
          </div>
        </div>

        {/* Submit and Cancel Buttons */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            marginTop: "20px",
            justifyContent: "center",
          }}
        >
             {/* 02-10  add loader*/}
                      <button
            type="submit"
            disabled={loading}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              borderRadius: "10px",
              width: "120px",
              height: "40px",
              backgroundColor: loading ? "#7bbbd6" : "#028fcd",
              border: "none",
              fontSize: "16px",
              color: "#ffffff",
              fontWeight: "700",
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? (
              <>
                <span
                  style={{
                    width: "18px",
                    height: "18px",
                    border: "3px solid rgba(255,255,255,0.4)",
                    borderTop: "3px solid #ffffff",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite",
                  }}
                ></span>
                Submitting...
              </>
            ) : (
              <>
                <img
                  src={submit}
                  alt="Submit"
                  style={{
                    width: "1.2rem",
                    paddingBottom: "3px",
                  }}
                />
                Submit
              </>
            )}
          </button>
          <button
            onClick={resetData}
            type="button"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "10px",
              width: "120px",
              height: "40px",
              backgroundColor: "#ad4238",

              border: "none",
              fontSize: "16px",
              color: "#ffffff",
              fontWeight: "700",
            }}
          >
            <img src={Cancel32} style={{ width: "1.2rem" }} />
            Cancel
          </button>
        </div>
      </Form>
    </div>
  );
};

export default CreateContractor;
